import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { TouchEffectContainer, TouchEffectItem } from './Styled'
import themeAssetshortEffectHeartSvg from '@theme/short-effect/heart.svg'

const PARTICLE_EASE_OUT_DELAY_MS = 100
const PARTICLE_EASE_OUT_TRANSITION_MS = 2000

interface Particle {
  id: number
  x: number
  y: number
  scale: number
  opacity: number
  rotation: number
}

const TouchEffect = forwardRef((props: any, ref) => {
  const [particles, setParticles] = useState<Particle[]>([])
  const controllerRef = useRef<AbortController | undefined>(undefined)

  useEffect(() => {
    const controller = new AbortController()
    controllerRef.current = controller
    return () => {
      controller.abort()
      controllerRef.current = undefined
    }
  }, [])

  const spawnEffect = async (
    x: number,
    y: number,
    startRotation: number = 0,
    endRotation: number = 0,
    startScale: number = 1,
    endScale: number = 1
  ) => {
    const signal = controllerRef.current?.signal
    const id = Math.random()
    const particle: Particle = {
      id,
      x,
      y,
      rotation: startRotation,
      scale: startScale,
      opacity: 1,
    }
    setParticles((list) => {
      return list.concat(particle)
    })
    await new Promise((resolve) => setTimeout(resolve, PARTICLE_EASE_OUT_DELAY_MS))
    if (signal?.aborted) return
    setParticles((list) => {
      return list.map((item) => {
        if (item.id === id) {
          return {
            id,
            x,
            y,
            rotation: endRotation,
            scale: endScale,
            opacity: 0,
          }
        } else {
          return item
        }
      })
    })
    await new Promise((resolve) => setTimeout(resolve, PARTICLE_EASE_OUT_TRANSITION_MS))
    if (signal?.aborted) return
    setParticles((list) => {
      return list.filter((item) => {
        return item.id !== id
      })
    })
  }

  const containerRef = useRef<HTMLDivElement>()

  useImperativeHandle(ref, () => ({
    spawnEffect,
    el: containerRef.current,
  }))

  return (
    <TouchEffectContainer {...props} ref={containerRef}>
      {particles.map((item, index) => {
        return (
          <TouchEffectItem
            key={index}
            style={{
              opacity: `${item.opacity}`,
              transform: `translate(${item.x}px, ${item.y}px) translate(-50%, -50%) rotate(${item.rotation}rad) scale(${item.scale})`,
            }}
            src={`${themeAssetshortEffectHeartSvg}`}
          />
        )
      })}
    </TouchEffectContainer>
  )
})

export default TouchEffect
